import React from 'react'
import Header from '../components/Header/Header'
import ClassWIse from '../components/class-wise/ClassWIse'

function ClassWIsePriv() {
  return (
    <div>
        <Header/>
        <ClassWIse/>
    </div>
  )
}

export default ClassWIsePriv